import React from 'react';
import { Link } from 'react-router-dom';
import './BlogDetails.css';
import blogImg1 from '../../assets/blog/img1.jpg';
import blogImg2 from '../../assets/blog/img2.jpg';
import blogImg3 from '../../assets/blog/img3.jpg';
import blogImg4 from '../../assets/blog/img4.jpg';
import blogImg5 from '../../assets/blog/img5.jpg';

const BlogDetails = () => {
    return (
        <div className="blog-details-page">

            {/* PAGE TITLE */}
            <header className="blog-header">
                <h1>Buying a property! These legal & tax traps can cost you big!</h1>
            </header>

            <div className="blog-container">

                {/* LEFT : BLOG CONTENT */}
                <main className="blog-content">

                    {/* FEATURE IMAGE */}
                    <div className="blog-feature">
                        <span className="blog-tag">Blog Tag</span>
                        <img src={blogImg1} alt="Blog Image" />
                    </div>

                    {/* BLOG INTRO */}
                    <h2>Buying a property! These legal & tax traps can cost you big!</h2>

                    <p>
                        “Planning to buy a new property? These legal and tax traps can cost you big!” — a question many homebuyers and investors ignore until it’s too late. Property purchase and taxation play a crucial role in determining the true cost of your investment.
                        Understanding property purchase tax obligations clearly before signing the agreement can protect you from unexpected notices, penalties, and long-term legal complications. Property purchase taxes are not limited to sellers—buyers also carry significant and ongoing compliance responsibilities.
                    </p>

                    {/* SECTION */}
                    <h3>The TDS Rule Explained</h3>
                    <p>
                        Planning to buy a new property? Lack of awareness about TDS obligations can lead to serious legal and tax complications. Under property purchase and taxation rules, if the property value is ₹50 lakh or more, the buyer is required to deduct 1% TDS and deposit it with the Income Tax Department.
                        When the seller is an NRI, higher TDS rates apply irrespective of the property value. Property purchase tax provisions clearly state that in cases of non-compliance, income tax notices are issued to the buyer, not the seller. Proper handling of TDS requirements is essential to avoid unnecessary legal and financial trouble.
                    </p>

                    {/* SECTION */}
                    <h3>Buying an Under-Valued Property Can Still Trigger Tax</h3>
                    <p>
                        Planning to buy a new property? Assuming that a lower purchase price always works in your favor can be a costly mistake. Under property purchase and taxation regulations, if the declared purchase value is lower than the government circle rate and the difference exceeds ₹50,000 and 10% of the transaction value, the excess amount may be treated as taxable income.
                        Income tax provisions apply even when discounts are genuine. Property purchase tax liabilities are determined by compliance rules—not intent—making it essential for buyers to exercise caution and plan transactions carefully.
                    </p>

                    {/* SECTION */}
                    <h3>PAN Is Mandatory for Property Transactions</h3>
                    <p>
                        Planning to buy a new property? Ignoring PAN compliance can lead to serious legal and tax issues. Under property purchase and taxation rules, PAN details of both the buyer and seller are mandatory for transactions valued at ₹10 lakh or more.
                        Failure to provide PAN may result in rejection of property registration. In certain states, registrars may also require Aadhaar as part of the compliance process. Understanding property purchase tax requirements early is crucial, as compliance begins even before the registration is completed.
                    </p>

                    {/* SECTION */}
                    <h3>Stamp Duty and Registration Costs Matter</h3>
                    <p>
                        Planning to buy a new property? Ignoring stamp duty and registration charges in your tax planning can prove costly. Under property purchase and taxation rules, these expenses can be added to the cost of acquisition, helping reduce capital gains tax when the property is sold.
                        A clear understanding of property purchase tax provisions enables buyers to legally optimize future tax liabilities. However, these benefits are allowed only when supported by proper documentation—making it essential to preserve original receipts and records carefully.
                    </p>

                    {/* SECTION */}
                    <h3>Property Disclosure in Income Tax Returns Is Mandatory</h3>
                    <p>
                        Planning to buy a new property? Overlooking legal and tax disclosures can cost you dearly—especially if property details are not reported in your Income Tax Return (ITR). Under property purchase and taxation rules, individuals with an annual income exceeding ₹50 lakh are required to disclose property assets in Schedule AL.
                        Clear explanations of property purchase tax disclosure norms reveal that non-reporting may trigger scrutiny and tax notices. Compliance doesn’t stop at property registration—it continues every financial year to ensure a legally secure and stress-free ownership journey.
                    </p>

                    {/* SECTION */}
                    <h3>Income Tax Department Tracks High-Value Property Deals</h3>
                    <p>
                        Planning to buy a new property? Hidden legal and tax traps can cost you significantly. High-value property transactions are closely monitored, and under the property purchase tax framework, any transaction valued at ₹30 lakh or more is automatically reported by the registrar to the Income Tax Department, along with the PAN details of both the buyer and seller.
                        These transactions are reflected in the Annual Information Statement (AIS), making transparency mandatory. In today’s digitally driven reporting system, compliance with property purchase tax regulations is no longer optional—it is essential for a smooth and legally secure investment.
                    </p>

                    {/* SECTION */}
                    <h3>Buying Property Is More Than Just Paperwork</h3>
                    <p>
                        Planning to buy a new property? Hidden legal and tax pitfalls can cost you heavily. Property purchases involve multiple legal and financial checks, and missing even a single requirement may lead to penalties, delayed registrations, or prolonged legal complications.
                        Understanding property purchase taxes clearly highlights why thorough due diligence is essential. With expert guidance and proper tax planning, you can ensure a smooth, secure, and stress-free property investment journey.
                    </p>

                    {/* AUTHOR NOTE */}
                    <p>
                        <strong>Jeevan Realty – Your Trusted Agency in Coimbatore</strong><br />
                        Jeevan Realty is a reliable real estate agency dedicated to helping you buy, sell, and invest in properties across Coimbatore. With a strong foundation of trust, transparency, and local market expertise, we provide end-to-end real estate solutions designed around your needs.
                        From residential homes and apartments to plots and commercial properties, our experienced team ensures a smooth, secure, and rewarding journey—from your first inquiry to final ownership.
                    </p>

                    {/* PREVIOUS LINK */}
                    <div className="blog-navigation">
                        <Link to="/blog">← Previous<br /><span>Property Renting Vs Owning</span></Link>
                    </div>

                </main>

                {/* RIGHT : SIDEBAR */}
                <aside className="blog-sidebar">

                    <h3>Related Post</h3>

                    {/* RELATED CARD */}
                    <div className="related-card">
                        <img src={blogImg2} alt="image" />
                        <h4>Real Estate brokers in Coimbatore</h4>
                        <p>Real Estate brokers in Coimbatore</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg3} alt="image" />
                        <h4>Houses for sale in Coimbatore</h4>
                        <p>Houses for sale in Coimbatore Looking for your dream home in a city that blends</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg4} alt="image" />
                        <h4>Selling your property quickly: A guide</h4>
                        <p>Property Selling Guide There are many reasons why a property owner might want to sell</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg5} alt="image" />
                        <h4>Real Estate in Coimbatore</h4>
                        <p>Real Estate in Coimbatore: A Growing Investment Destination Real Estate in Coimbatore is evolving rapidly,</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg2} alt="image" />
                        <h4>Commercial Property Trends</h4>
                        <p>Discover the latest trends in commercial real estate and maximize your ROI this year.</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg3} alt="image" />
                        <h4>First-Time Buyer's Checklist</h4>
                        <p>Essential tips and a complete checklist for buying your first home stress-free.</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                    <div className="related-card">
                        <img src={blogImg4} alt="image" />
                        <h4>Understanding Property Taxes</h4>
                        <p>A comprehensive guide to property taxes, legal fees, and hidden costs you should know.</p>
                        <Link to="/blog/details">view details »</Link>
                    </div>

                </aside>

            </div>
        </div>
    );
};

export default BlogDetails;
